<template>
  <div class="mb-20 flex flex-col space-y-4">
    <h3 class="heading-3"><slot /></h3>
    <h4 class="body-2"><slot name="subtitle" /></h4>
  </div>
</template>
